import { render, staticRenderFns } from "./OrderQrCode.vue?vue&type=template&id=0a1d21c2&scoped=true&"
import script from "./OrderQrCode.vue?vue&type=script&lang=js&"
export * from "./OrderQrCode.vue?vue&type=script&lang=js&"
import style0 from "./OrderQrCode.vue?vue&type=style&index=0&id=0a1d21c2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1d21c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDialog,VIcon,VTooltip})
